import styled, { css } from 'styled-components';
import { TRadioBlobSize, TRadioBlobVariant } from './index.tsx';
import { ColorKey } from '@template/theme/types/color.type.ts';

export const IconContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Circle = styled.span`
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  border-radius: 50%;
  background: currentColor;
`;

export const RadioBlob = styled.div<{
  $size: TRadioBlobSize;
  $variant: TRadioBlobVariant;
  $selected?: boolean;
  $disabled?: boolean;
  $readOnly?: boolean;
  $color: ColorKey;
}>`
  aspect-ratio: 1;
  border: 1px solid;
  transition: 0.2s ease-out;
  border-color: ${({ theme, $selected, $color }) =>
    $selected ? theme.colors[$color].default : theme.colors.default[300]};
  cursor: pointer;
  color: ${({ theme, $color }) => theme.colors[$color].default};
  background: ${({ theme }) => theme.colors.base};

  ${({ $readOnly, $color, $selected }) =>
    !$readOnly &&
    css`
      &:hover {
        background: ${({ theme }) =>
          theme.colors[$color][$selected ? 300 : 100]};
      }

      &:focus-within {
        box-shadow: 0 0 0 4px ${({ theme }) => theme.colors.outline};
      }
    `}

  ${({ theme, $variant, $selected, $color }) => {
    switch ($variant) {
      case 'radio':
        return css`
          border-radius: 50%;
        `;
      case 'check-circle':
        return css`
          border-radius: 50%;
          ${$selected &&
          css`
            border-color: ${theme.colors[$color].default};
            background: ${theme.colors[$color].default};
            color: ${theme.colors.base};
          `}
        `;
      case 'check':
      default:
        return css`
          border-radius: 4px;
        `;
    }
  }}

    ${({ $disabled, theme }) =>
    $disabled &&
    css`
      pointer-events: none;
      background: ${theme.colors.default[100]};
      border-color: ${theme.colors.default[100]};
      color: ${theme.colors.default[200]};
    `}

    ${({ $size }) => {
    switch ($size) {
      case 'lg':
        return css`
          width: 36px;
          height: 36px;
          min-width: 36px;
          min-height: 36px;

          ${IconContainer} {
            padding: 8px;
          }
        `;
      case 'md':
        return css`
          width: 28px;
          height: 28px;
          min-width: 28px;
          min-height: 28px;

          ${IconContainer} {
            padding: 3px;
          }
        `;
      case 'sm':
      default:
        return css`
          min-width: 16px;
          min-height: 16px;
          width: 16px;
          height: 16px;

          ${IconContainer} {
            padding: 2px;
          }
        `;
    }
  }}
`;
